import React from 'react'

const ProjectsListPlaceholderItem = () => (
  <div className="b-blink__link">
    <div className="b-blink__cover" />
    <div className="b-blink__title" />
    <p className="b-blink__meta">
      <strong className="b-blink__author" />
      <span className="b-blink__category" />
    </p>
    <p className="b-blink__meta">
      <span className="b-blink__amount">
        <svg
          className="b-icon b-icon--egg-0 b-blink__egg"
          dangerouslySetInnerHTML={{
            __html: '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-egg-0" />'
          }}
        />
        <span className="amount-text" />
      </span>
      <span className="b-blink__timeleft" />
    </p>
  </div>
)

export default ProjectsListPlaceholderItem
